export const VerificationBegin = 'VerificationBegin'
export const VerificationSuccess = 'VerificationSuccess'
